import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const AdvocateService = {

    getAdvocates: async (body) => {
    return axios.post(`${baseUrl}/advocates/list` , body)
    },
    addAdvocate: async (advocateData) => {
        return axios.post(`${baseUrl}/advocates/create`, advocateData)
    },
    updateAdvocate: async (advocateId, advocateData) => {

        return axios.put(`${baseUrl}/advocates/${advocateId}/update`, advocateData)
    },
    getAdvocateNames : async () => {
        return axios.get(`${baseUrl}/advocates/name-and-id`);
    },
    getAdvocateOpinionPropertyId : async (propertyId) => {
        return axios.get(`${baseUrl}/prospect-properties/${propertyId}/advocate-analysis/list`);
    }
   
}
export default AdvocateService
